import { useCurrentUser } from "~/hooks/useCurrentUser";
import { useReferralToken } from "./useReferralToken";

export const useShowReferAFriend = (): boolean => {
  const user = useCurrentUser();
  const referralToken = useReferralToken();

  if (user) return user.isEligibleForReferral;

  return !!referralToken;
};
